import { HTMLAttributes } from 'react';
import { cn } from '@/utils';

const varients = {
  primary:
    'bg-[#039BE5] rounded-[8px] overflow-hidden text-[#ffffff] hover:bg-[#0288D1] flex items-center justify-center gap-2 transition-colors',
  secondary:
    'bg-white rounded-[8px] border border-[#039BE5] overflow-hidden text-[#039BE5] hover:text-[#0288D1] hover:border-[#0288D1] flex items-center justify-center gap-2 transition-colors',
  link: 'bg-white rounded-[8px] overflow-hidden text-[#039BE5] hover:text-[#0288D1] flex items-center justify-center gap-2 transition-colors',
  ghost:
    'bg-white rounded-[8px] border border-[#039BE5] overflow-hidden text-[#039BE5] hover:text-[#0288D1] hover:border-[#0288D1] flex items-center justify-center gap-2 grayscale transition-colors',
  icon: 'p-2 rounded-[8px] text-gray-900 text-[1.5rem] hover:bg-gray-50 transition-colors',
};

const sizes = {
  normal: 'h-[44px] py-3 px-5 max-w-[470px]',
  small: 'h-[32px] py-2 px-4 max-w-[300px]',
  xs: 'h-[24px] py-1 px-2 max-w-[200px]',
};

interface IButtonProps extends HTMLAttributes<HTMLButtonElement> {
  variant?: keyof typeof varients;
  size?: keyof typeof sizes;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}

export default function Button({
  children,
  className,
  variant = 'primary',
  size = 'normal',
  type = 'button',
  style = {},
  disabled = false,
  ...props
}: IButtonProps) {
  return (
    <button
      type={type === 'submit' ? 'submit' : 'button'}
      className={cn(varients[variant], sizes[size], className, disabled ? 'cursor-not-allowed opacity-50' : '')}
      disabled={disabled}
      {...props}
      style={style}
    >
      {children}
    </button>
  );
}
